import {BaseService} from '../baseService.js';

/* 
 * Handles unit lookups
 */
export class UnitLookupService extends BaseService {

	constructor() {	
		super();
	}
	
	async getUnits(referenceType, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/unit-lookup/' + referenceType + params);
		return data;
	}	
	
	async getUnitsForCompany(companyId, referenceType, paging) {
		var params = '?';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		if (companyId) {
			params += '&companyId=' + companyId;
		}		
		var data = await this.makeGETRequest('/api/resource/unit-lookup/' + referenceType + params);
		return data;
	}	

	async getUnitGroups(companyId) {		
		var params = '';
		if (companyId && companyId !== 'undefined') {
			params = '?companyId=' + companyId;
		}
		var data = await this.makeGETRequest('/api/resource/unit-lookup/groups' + params);
		return data;
	}

};
